import { ModelApiService } from './BaseApiService'

export default class UserApiService extends ModelApiService {
  constructor() {
    super('me')
  }
}
